import API from '../api/api'
import {_exportDownloadLinkDecorator} from '../helper'

const SYNC_NOTIFICATIONS_PENDING = 'SYNC_NOTIFICATIONS_PENDING'
const SYNC_NOTIFICATIONS_PROGRESS = 'SYNC_NOTIFICATIONS_PROGRESS'
const SYNC_NOTIFICATIONS_RESPONSE = 'SYNC_NOTIFICATIONS_RESPONSE'

const SAVE_NOTIFICATIONS_PENDING = 'SAVE_NOTIFICATIONS_PENDING'
const SAVE_NOTIFICATIONS_PROGRESS = 'SAVE_NOTIFICATIONS_PROGRESS'
const SAVE_NOTIFICATIONS_RESPONSE = 'SAVE_NOTIFICATIONS_RESPONSE'
const SAVE_NOTIFICATIONS_ABORTED = 'SAVE_NOTIFICATIONS_ABORTED'

const EXPORT_NOTIFICATIONS_PENDING = 'EXPORT_NOTIFICATIONS_PENDING'
const EXPORT_NOTIFICATIONS_PROGRESS = 'EXPORT_NOTIFICATIONS_PROGRESS'
const EXPORT_NOTIFICATIONS_RESPONSE = 'EXPORT_NOTIFICATIONS_RESPONSE'
const IMPORT_NOTIFICATIONS_PENDING = 'IMPORT_NOTIFICATIONS_PENDING'
const IMPORT_NOTIFICATIONS_PROGRESS = 'IMPORT_NOTIFICATIONS_PROGRESS'
const IMPORT_NOTIFICATIONS_RESPONSE = 'IMPORT_NOTIFICATIONS_RESPONSE'
const RESET_ERRORS = 'RESET_ERRORS'
const CLEAR_EXPORT_URLS = 'CLEAR_EXPORT_URLS'

const initialState = {
  sync_notifications_pending: true,
  save_notifications_pending: false,
  export_notifications_pending: false,
  export_po_download_url: null,
  export_csv_download_url: null,
  import_notifications_pending: false,
  imported_entries: 0,
  error: false,
  progress: 0,
  notifications: [],
}

// REDUCER
export default (state = initialState, action) => {
  switch(action.type) {
    case RESET_ERRORS: {
      return {
        ...state,
        error: false,
      }
    }

    case SYNC_NOTIFICATIONS_PENDING: {
      return {
        ...state,
        progress: 0,
        sync_notifications_pending: true,
        export_po_download_url: null,
        export_csv_download_url: null,
        error: false,
      }
    }
    case SYNC_NOTIFICATIONS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case SYNC_NOTIFICATIONS_RESPONSE: {
      if(action.response.success === true) {
        return {
          ...state,
          sync_notifications_pending: false,
          error: false,
          notifications: action.response.notifications.slice()
        }
      } else {
        return {
          ...state,
          sync_notifications_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 0,
          },
        }
      }
    }

    case SAVE_NOTIFICATIONS_PENDING: {
      return {
        ...state,
        progress: 0,
        save_notifications_pending: true,
        error: false,
      }
    }
    case SAVE_NOTIFICATIONS_PROGRESS: {
      return {
        ...state,
        progress: action.progress
      }
    }
    // A save dropped because the merchant left the language never answers, and nothing refires
    // it the way a switch refires the sync - so the flag it set is cleared here. Not an error:
    // the merchant asked for the interruption.
    case SAVE_NOTIFICATIONS_ABORTED: {
      return {
        ...state,
        progress: 0,
        save_notifications_pending: false,
        error: false,
      }
    }
    case SAVE_NOTIFICATIONS_RESPONSE: {
      // The response echoes what was written for the language the save was issued for. The
      // abort races a response already on the wire, so it can still land after the merchant
      // selected another language - applying it then is what puts one language's text under another.
      if(action.stale === true) {
        return {
          ...state,
          save_notifications_pending: false,
          error: false,
        }
      }

      let error = false;
      let newNotifications = state.notifications.slice();
      action.response.forEach((response, i) => {
        if(response.success !== true) {
          error = {
            message: action.response,
            action: action.action,
          };
          let newNotification = newNotifications.find(x => x.id == action.items[i].id)
          newNotification.target = {...newNotification.target, ...action.items[i]}
        } else {
          let newNotification = newNotifications.find(x => x.id == response.notification.id)
          newNotification.progress = response.notification.progress
          newNotification.source = {...response.notification.source}
          newNotification.target = {...response.notification.target}
        }
      })
      return {
        ...state,
        notifications: newNotifications,
        save_notifications_pending: false,
        error: error
      }
    }

    case EXPORT_NOTIFICATIONS_PENDING: {
      return {
        ...state,
        progress: 0,
        export_notifications_pending: true,
        export_po_download_url: null,
        export_csv_download_url: null,
        error: false,
      }
    }
    case EXPORT_NOTIFICATIONS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case EXPORT_NOTIFICATIONS_RESPONSE: {
      if(action.response.success == true) {
        return {
          ...state,
          progress: 100,
          export_notifications_pending: false,
          export_po_download_url: _exportDownloadLinkDecorator(action.response.po_download_url, action.options),
          export_csv_download_url: _exportDownloadLinkDecorator(action.response.csv_download_url, action.options),
        }
      } else {
        return {
          ...state,
          progress: 100,
          export_notifications_pending: false
        }
      }
    }
    case IMPORT_NOTIFICATIONS_PENDING: {
      return {
        ...state,
        progress: 0,
        import_notifications_pending: true,
        import_cancelled: false,
        imported_entries: 0,
        error: false,
      }
    }
    case IMPORT_NOTIFICATIONS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case IMPORT_NOTIFICATIONS_RESPONSE: {
      // the merchant cancelled after reviewing the file, nothing was imported
      if(action.response && action.response.cancelled === true) {
        return {
          ...state,
          progress: 0,
          import_notifications_pending: false,
          import_cancelled: true
        }
      }
      let isOk = true;
      let importedEntries = 0;
      action.response.forEach(response => {
        if(response.success !== true) {
          isOk = false
        } else {
          importedEntries += response.imported_entries
        }
      })

      if(isOk == true) {
        return {
          ...state,
          progress: 100,
          import_notifications_pending: false,
          imported_entries: importedEntries
        }
      } else {
        return {
          ...state,
          progress: 100,
          import_notifications_pending: false,
          imported_entries: importedEntries,
          error: {
            message: action.response.filter(response => response.success !== true),
            action: action.action,
          }
        }
      }
    }
    case CLEAR_EXPORT_URLS: {
      return {
        ...state,
        progress: 0,
        export_notifications_pending: false,
        export_csv_download_url: null,
        export_po_download_url: null,
      }
    }
    default:
      return state
  }
}

// ACTIONS
export const resetErrors = () => {
  return dispatch => {
    dispatch({
      type: RESET_ERRORS
    });
  }
}
export const syncNotifications = (languageId, progress) => { 
  return dispatch => {
    dispatch({
      type: SYNC_NOTIFICATIONS_PENDING
    })

    API.syncNotifications(
      languageId,
      progress => {
        dispatch({
          type: SYNC_NOTIFICATIONS_PROGRESS,
          progress: progress
        })
      },
      response => {
        // A dropped sync is not dispatched at all: the switch that dropped it has already
        // started the sync for the language now on screen, and that one owns the pending flag.
        if(response && response.aborted === true) {
          return;
        }

        dispatch({
          type: SYNC_NOTIFICATIONS_RESPONSE,
          response: response,
          action: () => syncNotifications(languageId, progress)
        })
      }
    )
  }
}

export const saveNotifications = (language, items) => {  
  return (dispatch, getState) => {
    dispatch({
      type: SAVE_NOTIFICATIONS_PENDING
    })

    API.saveNotifications(
      language,
      items,
      progress => {
        dispatch({
          type: SAVE_NOTIFICATIONS_PROGRESS,
          progress: progress
        })
      },
      response => {
        if(response && response.aborted === true) {
          dispatch({
            type: SAVE_NOTIFICATIONS_ABORTED
          })
          return;
        }

        dispatch({
          type: SAVE_NOTIFICATIONS_RESPONSE,
          response: response,
          items: items,
          stale: getState().shop.shop.edit_language !== language,
          action: () => saveNotifications(language, items)
        })
      })
  }
}

export const exportNotifications = (language, options) => {
  return dispatch => {
    dispatch({
      type: EXPORT_NOTIFICATIONS_PENDING
    })

    API.exportNotifications(
      language,
      options,
      progress => {
        dispatch({
          type: EXPORT_NOTIFICATIONS_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: EXPORT_NOTIFICATIONS_RESPONSE,
          response: response,
          options: options,
          action: () => exportNotifications(language, options)
        }
      )
    })
  }
}

export const importNotifications = (file, fileType, language) => {
  return dispatch => {
    dispatch({
      type: IMPORT_NOTIFICATIONS_PENDING
    })

    API.importNotifications(
      file,
      fileType,
      language,
      progress => {
        dispatch({
          type: IMPORT_NOTIFICATIONS_PROGRESS,
          progress: progress
        })
      },
      response => {
        dispatch({
          type: IMPORT_NOTIFICATIONS_RESPONSE,
          response: response,
          action: () => importNotifications(file, fileType, language)
        }
      )
    })
  }
}

export const clearExportUrls = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_EXPORT_URLS
    });
  }
}